<template>
    <div class="notification-panel">
        <div class="email-settings-wrapper">
            <h2 class="panel-title">Email Notifications</h2>
            <rt-select class="email-select" type="floating" floatLabel="Preferred email" :options="emailList" value="0" :disabled="true"/>
        </div>
        <div class="notification-settings-wrapper">
            <h3 class="settings-title">Send me email notifications for:</h3>
            <div class="notification-wrapper">
                <div class="notification-setting">
                    <h3 class="settings-title">Activity updates</h3>
                    <p class="notification-description">New tasks assigned to you, and completion notifications for tasks you're a collaborator on</p>
                </div>
                <rt-switch class="notification-switch" :value="activityUpdateOn" @input="activityUpdateOn=$event"/>
            </div>
            <div class="notification-wrapper">
                <div class="notification-setting">
                    <h3 class="settings-title">Daily summaries</h3>
                    <p class="notification-description">New tasks assigned to you and upcoming due dates</p>
                </div>
                <rt-switch class="notification-switch" :value="dailySummaryOn" @input="dailySummaryOn=$event"/>
            </div>
            <div class="notification-wrapper">
                <div class="notification-setting">
                    <h3 class="settings-title">Weekly reports</h3>
                    <p class="notification-description">Status updates on projects in your portfolios</p>
                </div>
                <rt-switch class="notification-switch" :value="weeklyReportOn" @input="weeklyReportOn=$event"/>
            </div>
        </div>
        <div class="setting-panel-footer">
          <primary-button class="btn-close" @click="$emit('close')">Close</primary-button>
          <primary-button class="btn-save" @click="handleSaveNotification">Save</primary-button>
        </div>
    </div>
</template>

<script>
import RtSelect from '../Select.vue';
import RtCheckbox from '../RtCheckbox.vue';
import RtSwitch from '../RtSwitchInput.vue';
import PrimaryButton from '../PrimaryButton.vue';
import { getUser } from 'common/UserService';
import { updateUserSettingsOnly } from 'common/api';
import Toast from 'common/Toast';
export default {
  data() {
    return {
      loading: false,
      email: '',
      emailList: [],
      activityUpdateOn: true,
      dailySummaryOn: true,
      weeklyReportOn: true
    }
  },
  components: {
    RtSelect,
    RtSwitch,
    PrimaryButton
  },
  mounted() {
    const user = getUser();
    if (user) {
      this.email = user.email;
      this.emailList = [user.email];
      const userSettings = this.getUserSettings();
      this.activityUpdateOn = userSettings.activity_updates !== undefined ? userSettings.activity_updates : true;
      this.dailySummaryOn = userSettings.daily_summaries !== undefined ? userSettings.daily_summaries : true;
      this.weeklyReportOn = userSettings.weekly_reports !== undefined ? userSettings.weekly_reports : true;
    }
  },
  methods: {
    getUserSettings() {
      const user = getUser();
      const userSettings = user.userSettings ?  JSON.parse(user.userSettings) : {};
      return userSettings;
    },
    async handleSaveNotification() {
      if (this.loading) return;
      let userSettings = this.getUserSettings();
      userSettings.activity_updates = this.activityUpdateOn;
      userSettings.daily_summaries = this.dailySummaryOn;
      userSettings.weekly_reports = this.weeklyReportOn;
      userSettings = JSON.stringify(userSettings);

      this.loading = true;
      const result = await updateUserSettingsOnly(userSettings);
      if (result.success) {
        Toast.success(result.message);
        window.rt_bridge.session.user.userSettings = userSettings;
      } else {
        Toast.error(result.message);
      }
      this.loading = false;
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../variables';

.notification-panel {
  .panel-title {
    font-family: $title-font;
    font-weight: 700;
    font-size: 18px;
  }
  .email-select {
    width: 100%;
    margin-top: 24px;
    ::v-deep(.floating-select-info) {
      font-weight: 700;
    }
  }
  .notification-settings-wrapper {
    padding: 40px 0 20px;
    .settings-title {
      font-size: 14px;
      color: $title-dark-grey;
    }
    .notification-wrapper {
      padding: 12px 0;
      display: flex;
      align-items: flex-start;
      justify-content: space-between;
      padding: 12px 0;
      .notification-setting {
        margin-right: 40px;
        .notification-description {
          margin-top: 5px;
          font-size: 14px;
          color: $title-grey;
        }
      }
    }
  }
}
</style>

